"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3550],{

/***/ 3550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BloqueHTemplate": function() { return /* binding */ BloqueHTemplate; },
  "default": function() { return /* binding */ BloqueH_BloqueH; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 3 modules
var container = __webpack_require__(59203);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./components/atoms/text/index.ts + 1 modules
var atoms_text = __webpack_require__(61150);
;// CONCATENATED MODULE: ./components/organisms/BloqueH/BloqueH.tsx




/**
 * BloqueH
 */ var BloqueH = function(param) {
    var title = param.title, description = param.description, extendedText = param.extendedText, titleType = param.titleType, titleUppercase = param.titleUppercase, titleSize = param.titleSize, titleColor = param.titleColor, maxWidthTitle = param.maxWidthTitle, titleAlign = param.titleAlign, descriptionType = param.descriptionType, descriptionUppercase = param.descriptionUppercase, descriptionSize = param.descriptionSize, descriptionColor = param.descriptionColor, maxWidthDescription = param.maxWidthDescription, descriptionAlign = param.descriptionAlign, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-4 ".concat(className),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_text/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                as: titleType
            }, (maxWidthTitle || titleColor || titleAlign) && {
                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, titleColor && {
                    color: titleColor
                }, maxWidthTitle && {
                    maxWidth: "".concat(maxWidthTitle, "px")
                }), {
                    textAlign: titleAlign
                })
            }), {
                className: "u-headline ".concat(titleSize).concat(titleUppercase ? " uppercase" : " !normal-case"),
                children: title
            })),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_text/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                as: descriptionType
            }, (maxWidthDescription || descriptionColor || descriptionAlign) && {
                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, descriptionColor && {
                    color: descriptionColor
                }, maxWidthDescription && {
                    maxWidth: "".concat(maxWidthDescription, "px")
                }), {
                    textAlign: descriptionAlign
                })
            }), {
                className: "u-body ".concat(descriptionSize).concat(descriptionUppercase ? " uppercase" : " normal-case"),
                children: description
            })),
            extendedText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: (0,_object_spread/* default */.Z)({
                    textAlign: descriptionAlign
                }, maxWidthDescription ? {
                    maxWidth: "".concat(maxWidthDescription, "px")
                } : {
                    maxWidth: "100%"
                }),
                className: "u-body prose ".concat(descriptionSize, " ").concat(descriptionUppercase ? " uppercase" : " normal-case", " ").concat(className),
                dangerouslySetInnerHTML: {
                    __html: extendedText
                }
            })
        ]
    });
};
BloqueH.displayName = "BloqueH";

;// CONCATENATED MODULE: ./components/organisms/BloqueH/index.ts

/* harmony default export */ var organisms_BloqueH = (BloqueH);

;// CONCATENATED MODULE: ./lib/graphql/transformers/flexible/BloqueH.ts


var BloqueHTransformer = function(bloque) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bloque.title && {
        title: bloque.title
    }, bloque.description && {
        description: bloque.description
    }, bloque.extendedText && {
        extendedText: bloque.extendedText
    }), {
        titleType: bloque.titleType
    }), bloque.titleUppercase && {
        titleUppercase: true
    }), {
        titleSize: bloque.titleSize,
        titleColor: bloque.titleColor
    }), bloque.maxWidthTitle && {
        maxWidthTitle: bloque.maxWidthTitle
    }), {
        titleAlign: bloque.titleAlign,
        descriptionType: bloque.descriptionType
    }), bloque.descriptionUppercase && {
        descriptionUppercase: true
    }), {
        descriptionSize: bloque.descriptionSize,
        descriptionColor: bloque.descriptionColor
    }), bloque.maxWidthDescription && {
        maxWidthDescription: bloque.maxWidthDescription
    }), {
        descriptionAlign: bloque.descriptionAlign
    });
};

;// CONCATENATED MODULE: ./components/templates/flexible-content/BloqueH/BloqueH.tsx





/**
 * BloqueHTemplate
 */ var BloqueHTemplate = function(param) {
    var bloque = param.bloque, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        id: id,
        wrapper: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_BloqueH, (0,_object_spread/* default */.Z)({}, BloqueHTransformer(bloque)))
    });
};
/* harmony default export */ var BloqueH_BloqueH = (BloqueHTemplate);
BloqueHTemplate.displayName = "BloqueHTemplate";


/***/ })

}]);